import React, { useEffect } from 'react'
import { useState } from 'react';
import { Button, Switch, Table, Typography, Space, Image, Flex, Row, Col, Form } from 'antd'
import { ActionButton, Addfaq, AlertModal, FaqView, SearchInput } from '../../../components';
import { faqsData } from '../../../Data';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi, TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

let timer;
const {Text} = Typography;
const Faqtable = ({ setVisible, visible }) => {
    const [deleteitem,setDeleteItem] = useState(false)
    const [view, setView] = useState(false);
    const [edititem, setEditItem] = useState(null);
    const [form] = Form.useForm();
    const [deletionLoading, setDeletionLoading]= useState(false)
    const dispatch = useDispatch()
    const { faqData, loadingfaq, filters, pagination } = useSelector(state => state?.Faqsgetapi)
    

    useEffect(() => {
        dispatch(actionsApi?.getFaqApi({ ...filters, ...pagination, pageNo: 1 }))
        form.setFieldsValue({
            ...filters,
        })
    }, [])
    
    const call = (pageNo = 1, pageSize = 10) => {
        dispatch(actionsApi?.getFaqApi({ ...filters, pageNo, pageSize }))
    }

    function searchHandler(name, pageNo=1, pageSize=20) {
        dispatch(actionsApi?.getFaqApi({ ...filters, name, pageNo, pageSize }))
    }

    function debounce(func, delay) {
        return function(...args) {
            clearTimeout(timer)
            timer = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        };
    }
    const debouncedSearchHandler = debounce(searchHandler, 400)

    const onChange = (checked, row) => {
        const newStatus = checked ? 1 : 2;
        dispatch(actionsApi?.faqstatusResponse({ id: row.id, status: newStatus }));
        dispatch(actionsApi?.updateFaqStatus({ id: row.id, status: newStatus }));
    };


    const columns = [
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Title</Text>,
            dataIndex: 'title',
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Description</Text>,
            dataIndex: 'description',
            render: (_,row) => <Text ellipsis={{row:2}}>{row?.description}</Text>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (status) => {
                return (
                    status === 1 ? (
                        <Text className='active fs-12 badge-cs'>Active</Text>
                    ) : (
                        <Text className='inactive fs-12 badge-cs'>Inactive</Text>
                    )
                );
            },
            width: 170,
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Date</Text>,
            dataIndex: 'date',
            width: 170,
        },
        {
            title: <Text className='fs-15 fw-500 text-nowrap'>Action</Text>,
            key: 'action',
            fixed: 'right',
            width: 150,
            render: (_, row) => (
                <Space>
                    <Switch size='small' 
                        checked={row?.status === 1}
                        onChange={(checked) => onChange(checked, row)}
                    />
                    <ActionButton
                        title='View Faq'
                        shape="circle"
                        icon={<Image src='/assets/icons/view.png' width={18} preview={false} />}
                        onClick={() => {setView(row)}}
                        className='border0 bg-transparent'
                    />
                    <ActionButton
                        title='Edit Faq'
                        shape="circle"
                        icon={<Image src='/assets/icons/edit.png' width={18} preview={false} />}
                        onClick={() => { setVisible(true); setEditItem(row) }}
                        className='border0 bg-transparent'
                    />
                    <ActionButton
                        title='Delete Faq'
                        shape="circle"
                        icon={<Image src='/assets/icons/delete.png' width={18} preview={false} />}
                        className='border0 bg-transparent'
                        onClick={() => {setDeleteItem({name:row?.title, id: row?.id})}}
                    />
                </Space>
            ),
        },
    ];

    const DeleteFaqs= async ()=>{
        setDeletionLoading(true)
        let result= await apiCalls?.addFaqsApi?.DeleteFaqs(deleteitem?.id)
        if(result){
            setDeleteItem(null)
            searchHandler('')
        }
        setDeletionLoading(false)
    }


  return (
    <Flex vertical gap={20}>
        <Form
            form={form}
            layout="vertical"
        >
            <Row gutter={[16,16]} align={'middle'}>
                <Col lg={8} md={12} sm={24} xs={24}>
                    <SearchInput 
                        name='name'
                        placeholder='Search job'
                        prefix={<img src='/assets/icons/search.png' width={20} />}
                        className='border-light-gray pad-x ps-0 radius-8 fs-13 search-w'
                        onChange={(e)=> debouncedSearchHandler(e.target.value, 1, 20)}
                    />
                </Col>
            </Row>
        </Form>
        <Table
            size='large'
            columns={columns}
            dataSource={faqData}
            className='pagination'
            showSorterTooltip={false}
            scroll={{ x: 1000 }}
            pagination={{
                hideOnSinglePage: true,
                total: pagination?.totalRecords,
                pageSize: pagination?.pageSize,
                defaultPageSize: pagination?.pageSize,
                current: pagination?.pageNo,
                size: "default",
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: (total) => <Button className='brand-bg border0 text-white'>Total: {total}</Button>,
            }}
            loading = {
                {
                    ...TableLoader,
                    spinning: loadingfaq
                }
            }
        />
        <AlertModal
            visible={deleteitem}
            deleteitem={deleteitem}
            callBack={DeleteFaqs}
            deletionLoading={deletionLoading}
            onClose={()=>{setDeleteItem(false);}}
        />
        <Addfaq
            visible={visible}
            edititem={edititem}
            getFaqApi={call}
            onClose={() => {setVisible(false);setEditItem(null);}}
        />
        <FaqView
            view={view}
            onClose={() => {
            setView(false);
            }}
        />
    </Flex>
  )
}

export {Faqtable}